import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MentorFeedbackEventNote } from '@app/app/page-modules/admin/services/mentor-mentee/mentor-mentee-data.service';
import { LearnerFormAnswerNote } from '@app/app/page-modules/resource/models';
import { ReviewItem } from '@app/app/page-modules/reviews/models';
import { ReviewsState } from '@app/app/page-modules/reviews/store/reviews.state';
import { LocalTimeHelper } from '@app/app/shared/helpers/local-time-helper';
import { EditorContent } from '@app/app/shared/models';
import { Select } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ptl-review-comment-preview',
  templateUrl: './review-comment-preview.component.html',
  styleUrls: ['./review-comment-preview.component.scss'],
})
export class ReviewCommentPreviewComponent implements OnInit, OnDestroy {
  @Input() note: LearnerFormAnswerNote;
  @Input() mentorNote: MentorFeedbackEventNote;
  @Select(ReviewsState.reviewItem) reviewItem$: Observable<ReviewItem>;

  reviewItem: ReviewItem;
  content: EditorContent[] = [{ type: 'PARAGRAPH', content: '' }];
  private subscriptionEnd$ = new Subject<void>();

  get commentAuthor(): string {
    return this.note?.addedBy ?? this.mentorNote.author;
  }

  get commentCreatedAt(): string {
    if (this.note) {
      return LocalTimeHelper.getLocalDateTime(this.note.addedOn).format('DD MMM YYYY, HH:mm');
    } else {
      return LocalTimeHelper.getLocalDateTime(new Date(this.mentorNote.metadata.createdOn)).format('DD MMM YYYY, HH:mm');
    }
  }

  ngOnInit(): void {
    if (this.note?.message) {
      this.content = this.note.message;
    }
    if (this.mentorNote?.message) {
      this.content = this.mentorNote.message;
    }

    this.reviewItem$.pipe(takeUntil(this.subscriptionEnd$), filter(Boolean)).subscribe((item) => (this.reviewItem = item));
  }

  ngOnDestroy(): void {
    this.subscriptionEnd$.next();
    this.subscriptionEnd$.complete();
  }
}
